import Cookies from 'js-cookie'

const TokenKey = 'apk-Admin-Token'
const UserKey= 'username'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getUser() {
  return Cookies.get(UserKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function setUser(user) {
  return Cookies.set(UserKey, user)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
